import React from "react";

const BudgetIcon = () => {
  return (
    <svg viewBox="0 0 18 16.615">
      <g id="surface1" transform="translate(-31.578 -47.367)">
        <path d="M45.078,47.367a3.808,3.808,0,1,0,3.808,3.808A3.806,3.806,0,0,0,45.078,47.367Zm-.346,1.385h.692v.638a1.1,1.1,0,0,1,1.1,1.006h-.846c-.049-.225-.257-.362-.6-.362s-.568.149-.568.368c0,.17.146.276.465.346l.652.141c.673.149.976.433.976.952,0,.6-.468,1.02-1.185,1.12V53.6h-.692v-.635c-.706-.084-1.13-.441-1.185-1.02h.892c.07.238.295.37.66.37s.6-.146.6-.37c0-.168-.13-.273-.435-.341l-.627-.141c-.673-.146-1-.468-1-1,0-.565.43-.965,1.1-1.068Zm-9,6.923a2.053,2.053,0,0,0-.773.151l-3.38,1.233V62.6L34.5,61.33a1.386,1.386,0,0,1,1.084-.014l6.274,2.564h.005a1.017,1.017,0,0,0,.446.1,1.035,1.035,0,0,0,.511-.138,0,0,0,0,0,.005,0l6.22-3.454v0a1.037,1.037,0,0,0-.946-1.844v0l-4.751,1.98H42.309a1.038,1.038,0,0,0,.322-2.025L36.614,55.87H36.6A2.068,2.068,0,0,0,35.732,55.675Z" />
      </g>
    </svg>
  );
};

export default BudgetIcon;
